'use strict';

import {module} from '../app';
import { constantStrings } from "../constants/constantStrings";

module.service('environmentHelper', ['techpadConfig', function (techpadConfig) {
  let self = this;


    self.isIOSDevice = function () {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      }

}]);



// WEBPACK FOOTER //
// ./src/scripts/services/environmentHelper.js